import React, { memo } from "react";
import { Machine, Hand, Dry } from "../common/Icon";
import { Link } from "react-router-dom";

const Headline = memo(({ data }) => {
  return (
    <>
      {data ? (
        <div className="headline_container">
          <div>
            <h3>
              {data.series}
              <small>シリーズ</small>
            </h3>
            <div>
              <Machine opacity={Number(data.wash1) === 1 ? null : 0.2} />
              <Hand opacity={Number(data.wash2) === 1 ? null : 0.2} />
              <Dry opacity={Number(data.wash3) === 1 ? null : 0.2} />
            </div>
          </div>
          {["SU", "BL", "FT", "XE", "GD", "MS"].includes(data.series) && (
            <p className="bold haiban_kiji">
              <a
                className="bold"
                href="https://www.ny-k.co.jp/information/topic/260220/"
              >※こちらの生地シリーズは、現在の生地在庫限りで終了いたします。{" "}
              </a>
            </p>
          )}
          <h4
            dangerouslySetInnerHTML={{
              __html: data.headline,
            }}
          ></h4>
          <ul>
            {data.function1 !== "" ? (
              <li>
                <b>{data.function1}</b>
              </li>
            ) : null}
            {data.function2 !== "" ? (
              <li>
                <b>{data.function2}</b>
              </li>
            ) : null}
            {data.function3 !== "" ? (
              <li>
                <b>{data.function3}</b>
              </li>
            ) : null}
            {data.function4 !== "" ? (
              <li>
                <b>{data.function4}</b>
              </li>
            ) : null}
          </ul>
          <small>
            素材:
            {data.material1 +
              (data.material2 !== "" ? " " + data.material2 : "") +
              (data.material3 !== "" ? " " + data.material3 : "") +
              (data.material4 !== "" ? " " + data.material4 : "") +
              (data.material5 !== "" ? " " + data.material5 : "") +
              (data.material6 !== "" ? " " + data.material6 : "") +
              (data.material7 !== "" ? " " + data.material7 : "") +
              (data.material8 !== "" ? " " + data.material8 : "") +
              (data.materialinfo !== "" ? " " + data.materialinfo : "")}
            <br />
          </small>
          <a
            className="base_link"
            href={`/material/lineup/${data.series.toLowerCase()}.html`}
          >
            <span>生地詳細</span>
          </a>

        </div>
      ) : null}
    </>
  );
});

export default Headline;
